import React, { useState, useEffect } from 'react';
import './styles.scss'

const MultipleChoice = (props) => {
    // const [, updateState] = useState();
    // const forceUpdate = React.useCallback(() => updateState({}), []);

    let { question, questionText, answerPrefix, questionNumber, options, onOptionChange, category, language } = props
    const [selectedOption, setSelectedOption] = useState(null);
    const [id, setId] = useState(null);
    let answerKey = 'answer'
    if (language === 'isiZulu') answerKey = 'zuluAnswer'
    if (language === 'sesotho') answerKey = 'sesothoAnswer'

    const handleOptionChange = (event, question, score, answer, questionNumber, category) => {
        const value = event.target.value;
        setSelectedOption(value);
        setId(`${questionNumber}-${value}`)

        if (onOptionChange) {
            onOptionChange({ score, question, answer, questionNumber, category });
        }
    };

    return (
        <div>
            <p className='multiple-choice-question-header'>{`Question ${questionNumber}/15`}</p>
            <br />
            <p>{`${questionText}`}</p>
            <br />
            {answerPrefix !== "" && <p>{answerPrefix}</p>}
            <form className='multiple-choice-options-container' style={{ margin: 'auto' }}>
                {options.map((option, index) => (
                    <div className={`multiple-choice-option-card ${id === `${questionNumber}-${option.answer}` ? 'checked' : ''}`} key={index}>
                        <input
                            type="radio"
                            id={`option${index}`}
                            name={`question${questionNumber}`}
                            value={option.answer}
                            checked={id === `${questionNumber}-${option.answer}`}
                            onChange={(event) => handleOptionChange(event, question, option.score, option.answer, questionNumber, category)}
                        />
                        <label style={{ textAlign: 'center', fontWeight: 500, fontFamily: "Inter", fontSize: '14px', width: '100%' }} htmlFor={`option${index}`}>{option[answerKey] ? option[answerKey] : option.answer}</label>
                    </div>
                ))}
            </form>
        </div>
    );
}

export default MultipleChoice;
